

























import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import BasicConfigurator from "@/components/product-configuration/BasicConfigurator.vue";
import ImageSelector from "@/components/product-configuration/ImageSelector.vue";
import {Prop} from "vue-property-decorator";
import {ConfiguredImageDto, ImageDto, ImageRequirementDto, ProductDto} from "@swagger";
import HelpTooltip from "@/components/HelpTooltip.vue";

@Component({
  components: {HelpTooltip, ImageSelector, BasicConfigurator}
})
export default class SingleConfigurator extends BasicComponent {

  @Prop(Array) value: ConfiguredImageDto[];
  @Prop(Object) product: ProductDto;

  selectMultiple: boolean = false;
  selected: ConfiguredImageDto[] =  [];

  get selectedImageOrImages(): ConfiguredImageDto | ConfiguredImageDto[] {
    if (this.selectMultiple) {
      return this.value;
    }
    return this.value[0];
  }

  get eligibleImages(): ImageDto[] {
    return this.$store.getters.imageSelection.images.filter((image: ImageDto) => {
      return this.imageMatchesRequirement(image, this.requirement)
          && this.allPersons.some(person => person.imageIds.includes(image.uniqueId) && person.productIds.includes(this.product.id)); // At least one person having this image must be eligible for this product
    });
  }

  get requirement(): ImageRequirementDto {
    return this.product.imageRequirements[0];
  }

  get imagesForBasicConfigurator(): ConfiguredImageDto[][] {
    let images = this.value;
    if (! this.selectMultiple && this.value.length > 0) {
      images = [this.value[0]];
    }
    return images.map(image => [image]);
  }

  onSelect(images: ConfiguredImageDto[]): void {
    const selected = Array.isArray(images) ? images : [images];
    this.selected = selected;
    this.$emit("input", selected);
  }

  addedToBasket(): void {
    this.$emit("addedToBasket");
  }

  onError(error): void {
    this.$emit("error", error);
  }

  resetConfiguration() {
    this.$emit("input", []);
  }

}

